/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Shadow MCP server filter option with usage in the selected time window
 */
export type ToolUsageShadowServerFilterOption = {
  /**
   * Number of tool usage events observed for the Shadow MCP server
   */
  eventCount: number;
  /**
   * Observed Shadow MCP server name
   */
  serverName: string;
};

/** @internal */
export const ToolUsageShadowServerFilterOption$inboundSchema: z.ZodMiniType<
  ToolUsageShadowServerFilterOption,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    server_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
      "server_name": "serverName",
    });
  }),
);

export function toolUsageShadowServerFilterOptionFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageShadowServerFilterOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageShadowServerFilterOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageShadowServerFilterOption' from JSON`,
  );
}
